import { id } from 'date-fns/locale';
import { string } from 'yup';
import { ApolloClient } from '@apollo/client';
import gql from 'graphql-tag';
import { NumberingSeries } from 'shared-pages/shared/constants';

export class IdocExtraInput {
  id: number;
  idocId: number;
  containertypeId: number;
  containersQty: number;
  netWeight: number;
  containerTareWeight: number;
  grossWeight: number;
  tareWeight: number;
  materialId: number;
  ekaCode: string;
  unClass: string;

  constructor() {
    this.id = undefined;
    this.idocId = undefined;
    this.containertypeId = undefined;
    this.containersQty = undefined;
    this.netWeight = undefined;
    this.containerTareWeight = undefined;
    this.grossWeight = undefined;
    this.tareWeight = undefined;
    this.materialId = undefined;
    this.ekaCode = undefined;
    this.unClass = undefined;
  }
}

export class FormInput {
  id: number;
  idocMultiId: number;
  isMulti: boolean;
  isCancelled: boolean;
  identificationDocument: string;
  idocseriesId: number;
  idocPrefix: string;
  idocNumber: number;
  dateCollected: Date;
  wasteOriginTypeId: number;
  collectionPointId: number;
  fromWastereceptionpointId: number;
  collectionPointName: string;
  colpointAddressLine1: string;
  colpointAddressLine2: string;
  colpointAddressArea: string;
  colpointAddressCity: string;
  colpointPostalCode: string;
  colpointVatNumber: string;
  colpointTaxOffice: string;
  colpointPhoneNumber: string;
  colpointImaCode: string;
  colpointEmail: string;
  colpointCategoryId: number;
  regionId: number;
  subregionId: number;
  rbGeoAreaId: number;
  materialId: number;
  ekaCode: string;
  unClass: string;
  colpointSignFileId: number;
  colpointContactPerson: string;
  containersQty: number;
  netWeight: number;
  grossWeight: number;
  tareWeight: number;
  collectorId: number;
  collectorCompanyName: string;
  collectorCompanyAddress: string;
  collectorCompanyPhoneNumber: string;
  collectorCompanyVat: string;
  collectorCompanyTaxOffice: string;
  collectorCompanyImaCode: string;
  dateVehLoading: Date;
  vehicleId: number;
  vehPlateNumber: string;
  driverId: number;
  driverFullName: string;
  adrNumber: string;
  driverSignFileId: number;
  altRouteDescription: string;
  wasteDestinationTypeId: number;
  dateStorage: Date;
  wastereceptionpointId: number;
  wastereceptionpointCompanyName: string;
  wastereceptionpointCompanyAddress: string;
  wastereceptionpointCompanyPhoneNumber: string;
  wastereceptionpointCompanyVat: string;
  wastereceptionpointCompanyTaxOffice: string;
  wastereceptionpointCompanyImaCode: string;
  wastereceptionpointCompanyEmail: string;
  wastereceptionpointCompanyRegionId: number;
  wastereceptionpointCompanySubregionId: number;
  receptionPersonName: string;
  receptionSignFileId: number;
  receptionNetWeight: number;
  finaldestinationpointId: number;
  finaldestinationCompanyName: string;
  finaldestinationCompanyAddress: string;
  finaldestinationCompanyPhoneNumber: string;
  finaldestinationCompanyVat: string;
  finaldestinationCompanyTaxOffice: string;
  finaldestinationCompanyImaCode: string;
  finaldestinationCompanyEmail: string;
  finaldestinationCompanyRegionId: number;
  finaldestinationCompanySubregionId: number;
  finaldestinationCompanyNoteDocNumber: string;
  finalDestinationPersonName: string;
  finalDestinationSignFileId: number;
  finalDestinationDate: Date;
  finalDestinationNetWeight: number;
  rbAaDelivery: number;
  rbAaRoute: number;
  rbTotalRoutes: number;
  rbHourCriteria: number;
  rbTotalGrossWeight: number;
  distance: number;
  legacyAppId: string;
  recordDate: Date;
  collectionId: number;
  idocExtras: [IdocExtraInput];

  constructor() {
    this.id = undefined;
    this.idocMultiId = undefined;
    this.isMulti = undefined;
    this.isCancelled = undefined;
    this.identificationDocument = undefined;
    this.idocseriesId = undefined;
    this.idocPrefix = undefined;
    this.idocNumber = undefined;
    this.dateCollected = undefined;
    this.wasteOriginTypeId = undefined;
    this.collectionPointId = undefined;
    this.fromWastereceptionpointId = undefined;
    this.collectionPointName = undefined;
    this.colpointAddressLine1 = undefined;
    this.colpointAddressLine2 = undefined;
    this.colpointAddressArea = undefined;
    this.colpointAddressCity = undefined;
    this.colpointPostalCode = undefined;
    this.colpointVatNumber = undefined;
    this.colpointTaxOffice = undefined;
    this.colpointPhoneNumber = undefined;
    this.colpointImaCode = undefined;
    this.colpointEmail = undefined;
    this.colpointCategoryId = undefined;
    this.regionId = undefined;
    this.subregionId = undefined;
    this.rbGeoAreaId = undefined;
    this.materialId = undefined;
    this.ekaCode = undefined;
    this.unClass = undefined;
    this.colpointSignFileId = undefined;
    this.colpointContactPerson = undefined;
    this.containersQty = undefined;
    this.netWeight = undefined;
    this.grossWeight = undefined;
    this.tareWeight = undefined;
    this.collectorId = undefined;
    this.collectorCompanyName = undefined;
    this.collectorCompanyAddress = undefined;
    this.collectorCompanyPhoneNumber = undefined;
    this.collectorCompanyVat = undefined;
    this.collectorCompanyTaxOffice = undefined;
    this.collectorCompanyImaCode = undefined;
    this.dateVehLoading = undefined;
    this.vehicleId = undefined;
    this.vehPlateNumber = undefined;
    this.driverId = undefined;
    this.driverFullName = undefined;
    this.adrNumber = undefined;
    this.driverSignFileId = undefined;
    this.altRouteDescription = undefined;
    this.wasteDestinationTypeId = undefined;
    this.dateStorage = undefined;
    this.wastereceptionpointId = undefined;
    this.wastereceptionpointCompanyName = undefined;
    this.wastereceptionpointCompanyAddress = undefined;
    this.wastereceptionpointCompanyPhoneNumber = undefined;
    this.wastereceptionpointCompanyVat = undefined;
    this.wastereceptionpointCompanyTaxOffice = undefined;
    this.wastereceptionpointCompanyImaCode = undefined;
    this.wastereceptionpointCompanyEmail = undefined;
    this.wastereceptionpointCompanyRegionId = undefined;
    this.wastereceptionpointCompanySubregionId = undefined;
    this.receptionPersonName = undefined;
    this.receptionSignFileId = undefined;
    this.receptionNetWeight = undefined;
    this.finaldestinationpointId = undefined;
    this.finaldestinationCompanyName = undefined;
    this.finaldestinationCompanyAddress = undefined;
    this.finaldestinationCompanyPhoneNumber = undefined;
    this.finaldestinationCompanyVat = undefined;
    this.finaldestinationCompanyTaxOffice = undefined;
    this.finaldestinationCompanyImaCode = undefined;
    this.finaldestinationCompanyEmail = undefined;
    this.finaldestinationCompanyRegionId = undefined;
    this.finaldestinationCompanySubregionId = undefined;
    this.finaldestinationCompanyNoteDocNumber = undefined;
    this.finalDestinationPersonName = undefined;
    this.finalDestinationSignFileId = undefined;
    this.finalDestinationDate = undefined;
    this.finalDestinationNetWeight = undefined;
    this.rbAaDelivery = undefined;
    this.rbAaRoute = undefined;
    this.rbTotalRoutes = undefined;
    this.rbHourCriteria = undefined;
    this.rbTotalGrossWeight = undefined;
    this.distance = undefined;
    this.legacyAppId = undefined;
    this.recordDate = undefined;
    this.collectionId = undefined;
    this.idocExtras = undefined;
  }
}

export const gqlGetQuery = gql`
  query getIdocs($limit: Int, $offset: Int, $order: String, $where: String) {
    getIdocs(limit: $limit, offset: $offset, order: $order, where: $where) {
      data {
        id
        idocPrefix
        identificationDocument
        dateCollected
        collectionPointName
        colpointAddressLine1
        collectionPointId
        collectorCompanyName
        wastereceptionpointCompanyName
        dateStorage
        vehPlateNumber
        driverFullName
        netWeight
        receptionNetWeight
        finalDestinationDate
        finalDestinationNetWeight
        finaldestinationCompanyName
        finaldestinationCompanyNoteDocNumber
      }
      recordCount
    }
  }
`;

export const gqlGetQueryExcel = gql`
  query getIdocs($limit: Int, $offset: Int, $order: String, $where: String) {
    getIdocs(limit: $limit, offset: $offset, order: $order, where: $where) {
      data {
        id
        idocMultiId
        isMulti
        isCancelled
        identificationDocument
        idocseriesId
        edocSeries {
          id
          name
        }
        idocPrefix
        idocNumber
        dateCollected
        wasteOriginTypeId
        wasteOriginType {
          id
          name
        }
        collectionPointId
        collectionpoint {
          id
          name
        }
        fromWastereceptionpointId
        fromWastereceptionpoint {
          id
          name
        }
        collectionPointName
        colpointAddressLine1
        colpointAddressLine2
        colpointAddressArea
        colpointAddressCity
        colpointPostalCode
        colpointVatNumber
        colpointTaxOffice
        colpointImaCode
        colpointPhoneNumber
        colpointEmail
        colpointCategoryId
        colpointCategory {
          name
        }
        regionId
        region {
          id
          name
        }
        subregionId
        subregion {
          id
          name
        }
        materialId
        material {
          name
        }
        ekaCode
        unClass
        colpointContactPerson
        containersQty
        netWeight
        grossWeight
        tareWeight
        collectorId
        collector {
          name
        }
        collectorCompanyName
        collectorCompanyAddress
        collectorCompanyPhoneNumber
        collectorCompanyVat
        collectorCompanyTaxOffice
        collectorCompanyImaCode
        dateVehLoading
        vehicleId
        vehPlateNumber
        driverId
        driverFullName
        adrNumber
        altRouteDescription
        wasteDestinationTypeId
        wasteDestinationType {
          id
          name
        }
        dateStorage
        wastereceptionpointId
        wastereceptionpointCompanyName
        wastereceptionpointCompanyAddress
        wastereceptionpointCompanyPhoneNumber
        wastereceptionpointCompanyVat
        wastereceptionpointCompanyTaxOffice
        wastereceptionpointCompanyImaCode
        wastereceptionpointCompanyRegionId
        wastereceptionpointCompanyRegion {
          id
          name
        }
        wastereceptionpointCompanySubregionId
        wastereceptionpointCompanySubregion {
          id
          name
        }
        wastereceptionpointCompanyEmail
        wastereceptionpointNoteDocNumber
        receptionPersonName
        receptionNetWeight
        finaldestinationpointId
        finaldestinationpoint {
          id
          name
          wasteDestinationTypeId
          wastedestinationtype {
            id
            name
          }
        }
        finaldestinationCompanyName
        finaldestinationCompanyAddress
        finaldestinationCompanyPhoneNumber
        finaldestinationCompanyVat
        finaldestinationCompanyTaxOffice
        finaldestinationCompanyImaCode
        finaldestinationCompanyEmail
        finaldestinationCompanyRegionId
        finaldestinationCompanyRegion {
          id
          name
        }
        finaldestinationCompanySubregionId
        finaldestinationCompanySubregion {
          id
          name
        }
        finaldestinationCompanyNoteDocNumber
        finalDestinationPersonName
        finalDestinationSignFileId
        finalDestinationDate
        finalDestinationNetWeight
        finaldestinationCompanyNoteDocNumber
        finalDestinationItransId
        finalDestinationITrans {
          id
          code
        }
        collectionId
        distance
        recordDate
        firstDate
        lastDate
        firstUser
        lastUser
        idocExtras {
          id
          idocId
          containertypeId
          containertype {
            id
            name
          }
          containersQty
          netWeight
          containerTareWeight
          materialId

          ekaCode
          unClass
        }
      }
      recordCount
    }
  }
`;

export const gqlGetByIdQuery = gql`
  query getIdocById($id: Int) {
    getIdocById(id: $id) {
      id
      idocMultiId
      isMulti
      isCancelled
      identificationDocument
      idocseriesId
      idocPrefix
      idocNumber
      dateCollected
      wasteOriginTypeId
      collectionPointId
      fromWastereceptionpointId
      collectionPointName
      colpointAddressLine1
      colpointAddressLine2
      colpointAddressArea
      colpointAddressCity
      colpointPostalCode
      colpointVatNumber
      colpointTaxOffice
      colpointImaCode
      colpointPhoneNumber
      colpointEmail
      colpointCategoryId
      rbGeoAreaId
      regionId
      subregionId
      materialId
      ekaCode
      unClass
      colpointSignFileId
      colpointContactPerson
      containersQty
      netWeight
      grossWeight
      tareWeight
      collectorId
      collectorCompanyName
      collectorCompanyAddress
      collectorCompanyPhoneNumber
      collectorCompanyVat
      collectorCompanyTaxOffice
      collectorCompanyImaCode
      dateVehLoading
      vehicleId
      vehPlateNumber
      driverId
      driverFullName
      adrNumber
      driverSignFileId
      altRouteDescription
      wasteDestinationTypeId
      dateStorage
      wastereceptionpointId
      wastereceptionpointCompanyName
      wastereceptionpointCompanyAddress
      wastereceptionpointCompanyPhoneNumber
      wastereceptionpointCompanyVat
      wastereceptionpointCompanyTaxOffice
      wastereceptionpointCompanyImaCode
      wastereceptionpointCompanyRegionId
      wastereceptionpointCompanySubregionId
      wastereceptionpointCompanyEmail
      wastereceptionpointNoteDocNumber
      receptionPersonName
      receptionSignFileId
      receptionNetWeight
      finaldestinationpointId
      wasteDestinationTypeId
      finaldestinationpoint {
        id
        name
        wasteDestinationTypeId
        wastedestinationtype {
          id
          name
        }
      }
      finaldestinationCompanyName
      finaldestinationCompanyAddress
      finaldestinationCompanyPhoneNumber
      finaldestinationCompanyVat
      finaldestinationCompanyTaxOffice
      finaldestinationCompanyImaCode
      finaldestinationCompanyEmail
      finaldestinationCompanyRegionId
      finaldestinationCompanySubregionId
      finaldestinationCompanyNoteDocNumber
      finalDestinationItransId
      finalDestinationITrans {
        id
        code
      }
      finalDestinationPersonName
      finalDestinationSignFileId
      finalDestinationDate
      finalDestinationNetWeight
      rbAaDelivery
      rbAaRoute
      rbTotalRoutes
      rbHourCriteria
      rbTotalGrossWeight
      distance
      legacyAppId
      recordDate
      firstDate
      lastDate
      firstUser
      lastUser
      collectionId
      collection {
        id
        code
      }
      iTransLineId
      iTransLine {
        id
        itransId
        internalTransaction {
          id
          code
        }
      }
      transferredWithITransId
      transferredWithITrans {
        id
        code
        transactionDate
        wasteOriginTypeId
        toWastereceptionpoint {
          id
          name
          code
        }
        fromWastereceptionpoint {
          id
          name
        }
        fromCollectionpoint {
          id
          name
        }
      }
      idocExtras {
        id
        idocId
        containertypeId
        containertype {
          id
          name
        }
        containersQty
        netWeight
        containerTareWeight
        materialId

        ekaCode
        unClass
      }
    }
  }
`;

export const gqlAdd = gql`
  mutation addIdoc($data: IdocInput) {
    addIdoc(data: $data) {
      id
    }
  }
`;

export const gqlUpdate = gql`
  mutation updateIdoc($data: IdocInput) {
    updateIdoc(data: $data) {
      id
    }
  }
`;

export const gqlDelete = gql`
  mutation deleteIdoc($id: Int) {
    deleteIdoc(id: $id)
  }
`;

export const gqlCanAddIdoc = gql`
  mutation canAddIdoc($collectorId: Int) {
    canAddIdoc(collectorId: $collectorId)
  }
`;

export async function getWasteReceptionPointById(
  client: ApolloClient<object>,
  id: number,
): Promise<any> {
  const gqlScript = gql`
    query getWastereceptionpointById($id: Int) {
      getWastereceptionpointById(id: $id) {
        id
        wasteDestinationTypeId
        name
        phone
        email
        companyVat
        companyTaxOffice
        imaCode
        regionId
        subregionId
        imaCode
        addressLine1
        addressLine2
        addressCity
        addressArea
        postalCode
        receptionPersonName
      }
    }
  `;
  const ret = await client.query({
    query: gqlScript,
    variables: { id },
    fetchPolicy: 'network-only',
  });

  return ret?.data?.getWastereceptionpointById;
}

export async function getDriverByUserId(client: ApolloClient<object>, id: number): Promise<any> {
  const gqlScript = gql`
    query getQuery($where: String) {
      getDrivers(where: $where) {
        data {
          id
          name
          userId
          adrNumber
          user {
            id
            fullName
            signatureFileId
          }
        }
      }
    }
  `;
  const where = {
    userId: id,
  };
  const ret = await client.query({
    query: gqlScript,
    variables: { where: JSON.stringify(where) },
    fetchPolicy: 'network-only',
  });

  return ret?.data?.getDrivers?.data[0];
}

export async function getDriverById(client: ApolloClient<object>, id: number): Promise<any> {
  const gqlScript = gql`
    query getDriverById($id: Int) {
      getDriverById(id: $id) {
        id
        name
        userId
        adrNumber
        user {
          id
          fullName
          signatureFileId
        }
      }
    }
  `;
  return new Promise((resolve, reject) => {
    client
      .query<any, { id: number }>({
        query: gqlScript,
        variables: { id },
      })
      .then((res) => {
        if (res.data[Object.keys(res.data)[0]] !== null) {
          resolve(res.data[Object.keys(res.data)[0]]);
        } else {
          reject(res.errors[0].message);
        }
      })
      .catch((err) => reject(err));
  });
}

export async function getVehicleById(client: ApolloClient<object>, id: number): Promise<any> {
  const gqlScript = gql`
    query getVehicleById($id: Int) {
      getVehicleById(id: $id) {
        id
        plateNumber
      }
    }
  `;
  return new Promise((resolve, reject) => {
    client
      .query<any, { id: number }>({
        query: gqlScript,
        variables: { id },
      })
      .then((res) => {
        if (res.data[Object.keys(res.data)[0]] !== null) {
          resolve(res.data[Object.keys(res.data)[0]]);
        } else {
          reject(res.errors[0].message);
        }
      })
      .catch((err) => reject(err));
  });
}
export async function getCollectionById(client: ApolloClient<object>, id: number): Promise<any> {
  const gqlScript = gql`
    query getCollectionById($id: Int) {
      getCollectionById(id: $id) {
        id
        collectionPointId
        collectionpoint {
          id
          name
          phone
          email
          addressLine1
          addressLine2
          addressCity
          addressArea
          postalCode
          regionId
          contactPerson
        }
      }
    }
  `;
  return new Promise((resolve, reject) => {
    client
      .query<any, { id: number }>({
        query: gqlScript,
        variables: { id },
      })
      .then((res) => {
        if (res.data[Object.keys(res.data)[0]] !== null) {
          resolve(res.data[Object.keys(res.data)[0]]);
        } else {
          reject(res.errors[0].message);
        }
      })
      .catch((err) => reject(err));
  });
}

export async function getIdocwastetypeById(client: ApolloClient<object>, id: number): Promise<any> {
  const gqlScript = gql`
    query getQuery($id: Int) {
      getIdocwastetypeById(id: $id) {
        id
        wasteTypeName
        defEkaCode
        ekaCodeValues
        defUnClass
        unClassValues
      }
    }
  `;

  const ret = await client.query({
    query: gqlScript,
    variables: { id },
    fetchPolicy: 'network-only',
  });

  return ret?.data?.getIdocwastetypeById;
}

export function getCollectionpointById(client: ApolloClient<object>, id: number): Promise<any> {
  return new Promise((resolve, reject) => {
    client
      .query<any, { id: number }>({
        query: gql`
          query getCollectionpointById($id: Int) {
            getCollectionpointById(id: $id) {
              id
              name
              phone
              email
              categoryId
              groupId
              subgroupId
              subsubgroupId
              companyVat
              companyTaxOffice
              imaCode
              addressLine1
              addressLine2
              addressCity
              addressArea
              postalCode
              regionId
              subregionId
              contactPerson
            }
          }
        `,
        variables: { id },
      })
      .then((res) => {
        if (res.data.getCollectionpointById !== null) {
          resolve(res.data.getCollectionpointById);
        } else {
          reject(res.errors[0].message);
        }
      })
      .catch((err) => reject(err));
  });
}

export async function getWasteReceptionPoint(
  client: ApolloClient<object>,
  where: any,
): Promise<any> {
  const gqlScript = gql`
    query getWastereceptionpoints($where: String) {
      getWastereceptionpoints(where: $where) {
        data {
          id
          name
          isActive
          addressLine1
          phone
          companyVat
          companyTaxOffice
          receptionPersonName
        }
        recordCount
      }
    }
  `;
  const ret = await client.query({
    query: gqlScript,
    variables: { where: JSON.stringify(where) },
    fetchPolicy: 'network-only',
  });

  return ret?.data?.getWastereceptionpoints;
}

export async function getContainertypes(client: ApolloClient<object>, where: any): Promise<any> {
  const gqlScript = gql`
    query getContainertypes($limit: Int, $offset: Int, $order: String, $where: String) {
      getContainertypes(limit: $limit, offset: $offset, order: $order, where: $where) {
        data {
          id
          name
        }
        recordCount
      }
    }
  `;
  const ret = await client.query({
    query: gqlScript,
    variables: { where: JSON.stringify(where) },
    fetchPolicy: 'network-only',
  });

  return ret?.data?.getContainertypes;
}

export async function getCollectorById(client: ApolloClient<object>, id: number): Promise<any> {
  const gqlScript = gql`
    query getCollectorById($id: Int) {
      getCollectorById(id: $id) {
        id
        name
        companyVat
        companyTaxOffice
        imaCode
        contractNo
        contractSignDate
        contractExpDate
        formalName
        addressLine1
        addressLine2
        addressArea
        addressCity
        postalCode
        phone
        mobile
        fax
        email
        email2
        contactperson
        notes
      }
    }
  `;

  return new Promise((resolve, reject) => {
    client
      .query<any, { id: number }>({
        query: gqlScript,
        variables: { id },
      })
      .then((res) => {
        if (res.data[Object.keys(res.data)[0]] !== null) {
          resolve(res.data[Object.keys(res.data)[0]]);
        } else {
          reject(res.errors[0].message);
        }
      })
      .catch((err) => reject(err));
  });
}

export async function getMaterialById(client: ApolloClient<object>, id: number): Promise<any> {
  const gqlScript = gql`
    query getQuery($id: Int) {
      getMaterialById(id: $id) {
        id
        name
        defEkaCode
        ekaCodeValues
        defUnClass
        unClassValues
      }
    }
  `;

  const ret = await client.query({
    query: gqlScript,
    variables: { id },
    fetchPolicy: 'network-only',
  });

  return ret?.data?.getMaterialById;
}

export async function getCollectorIdocSeriesId(
  client: ApolloClient<object>,
  collectorId: number,
): Promise<any> {
  const gqlScript = gql`
    query getEdocSeries($where: String, $offset: Int, $limit: Int, $order: String) {
      getEdocSeries(where: $where, offset: $offset, limit: $limit, order: $order) {
        data {
          id
          name
          docPrefix
        }
        recordCount
      }
    }
  `;

  return new Promise((resolve, reject) => {
    const where = {
      collectorId: collectorId,
      seriestypeId: NumberingSeries.IDocs,
    };
    client
      .query<any, any>({
        query: gqlScript,
        variables: { where: JSON.stringify(where) },
      })
      .then((res) => {
        if (res.data[Object.keys(res.data)[0]] !== null) {
          resolve(res.data[Object.keys(res.data)[0]]);
        } else {
          reject(res.errors[0].message);
        }
      })
      .catch((err) => reject(err));
  });
}
